
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { TextField } from '@material-ui/core';
import { Controller } from "react-hook-form";
import { ClassNameMap } from '@material-ui/styles';
import KPILabel from './KPILabel';

interface AgedCareKPIProps {
    parentClasses: ClassNameMap,
    StarIcon: any,
    control: any,
    isItVisible: boolean
}


const useStyles = makeStyles((theme) => ({
    kpiLabelText: {
        color: 'white',
        lineHeight: '40px'
    },
    kpiLabel: {
        height: 40,
        paddingLeft: 20,
        paddingRight: 20
    },
    rootGridHidden:{
       display: 'none'
    }
}));

const redAlert = '#E05151';
const yellowAlert = '#F4B827';

const AgedCareKPI: React.FC<AgedCareKPIProps> = ({
    parentClasses,
    StarIcon,
    control,
    isItVisible
}) => {
    const classes = useStyles();
    const rootClass = isItVisible?parentClasses.grid:classes.rootGridHidden;
    return (
        <>
            <Grid container item xs={12} spacing={3} style={{ marginTop: 20 }} className={rootClass}>
                <Grid item xs={12}>
                    <div className={parentClasses.textFieldLable}><StarIcon />Medical Response KPI</div>
                </Grid>
                <Grid container item xs={12} lg={3} sm={8} md={6} spacing={1}>
                    <Grid item xs={12}>
                        <div className={parentClasses.textFieldLable}>Time To Acknowledge (minutes)</div>
                    </Grid>
                    <Grid container item xs={12} spacing={0} className={parentClasses.grid}>
                        <KPILabel labelText="Yellow alert if above" backgroundColor={yellowAlert} parentClasses={classes} />
                        <Grid item xs={4}>
                            <Controller
                                control={control}
                                as={<TextField type="number" classes={{ root: parentClasses.textFieldRoot }} InputProps={{ classes: { root: parentClasses.textFieldInput }, style: { borderRadius: 0 } }} variant='outlined'>
                                </TextField>}
                                name="timeToAcknowledgeYellowAlert"
                                defaultValue=''
                            />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={0} className={parentClasses.grid}>
                        <KPILabel labelText="Red alert if above" backgroundColor={redAlert} parentClasses={classes} />
                        <Grid item xs={4}>
                            <Controller
                                control={control}
                                as={<TextField type="number" classes={{ root: parentClasses.textFieldRoot }} InputProps={{ classes: { root: parentClasses.textFieldInput }, style: { borderRadius: 0 } }} variant='outlined'>
                                </TextField>}
                                name="timeToAcknowledgeRedAlert"
                                defaultValue='' />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container item xs={12} lg={3} sm={8} md={6} spacing={1}>
                    <Grid item xs={12}>
                        <div className={parentClasses.textFieldLable}>Time To Attend (minutes)</div>
                    </Grid>
                    <Grid container item xs={12} spacing={0} className={parentClasses.grid}>
                        <KPILabel labelText="Yellow alert if above" backgroundColor={yellowAlert} parentClasses={classes} />
                        <Grid item xs={4}>
                            <Controller
                                control={control} as={<TextField type="number" classes={{ root: parentClasses.textFieldRoot }} InputProps={{ classes: { root: parentClasses.textFieldInput }, style: { borderRadius: 0 } }} variant='outlined'>
                                </TextField>}
                                name="timeToAttendYellowAlert"
                                defaultValue='' />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={0} className={parentClasses.grid}>
                        <KPILabel labelText="Red alert if above" backgroundColor={redAlert} parentClasses={classes} />
                        <Grid item xs={4}>
                            <Controller
                                control={control} as={<TextField type="number" classes={{ root: parentClasses.textFieldRoot }} InputProps={{ classes: { root: parentClasses.textFieldInput }, style: { borderRadius: 0 } }} variant='outlined'>
                                </TextField>} name="timeToAttendRedAlert" defaultValue='' />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container item xs={12} lg={3} sm={8} md={6} spacing={1}>
                    <Grid item xs={12}>
                        <div className={parentClasses.textFieldLable}>Callouts Per Location Per Day</div>
                    </Grid>
                    <Grid container item xs={12} spacing={0} className={parentClasses.grid}>
                        <KPILabel labelText="Yellow alert if below" backgroundColor={yellowAlert} parentClasses={classes} />
                        <Grid item xs={4}>
                            <Controller
                                control={control} as={<TextField type="number" classes={{ root: parentClasses.textFieldRoot }} InputProps={{ classes: { root: parentClasses.textFieldInput }, style: { borderRadius: 0 } }} variant='outlined'>
                                </TextField>} name="calloutsPerDayYellowAlert" defaultValue='' />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={0} className={parentClasses.grid}>
                        <KPILabel labelText="Red alert if below" backgroundColor={redAlert} parentClasses={classes} />
                        <Grid item xs={4}>
                            <Controller
                                control={control} as={<TextField type="number" classes={{ root: parentClasses.textFieldRoot }} InputProps={{ classes: { root: parentClasses.textFieldInput }, style: { borderRadius: 0 } }} variant='outlined'>
                                </TextField>} name="calloutsPerDayRedAlert" defaultValue='' />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container item xs={12} lg={3} sm={8} md={6} spacing={1}>
                    <Grid item xs={12}>
                        <div className={parentClasses.textFieldLable}>Average Post-callout NPS Rating</div>
                    </Grid>
                    <Grid container item xs={12} spacing={0} className={parentClasses.grid}>
                        <KPILabel labelText="Yellow alert if below" backgroundColor={yellowAlert} parentClasses={classes} />
                        <Grid item xs={4}>
                            <Controller
                                control={control} as={<TextField type="number" classes={{ root: parentClasses.textFieldRoot }} InputProps={{ classes: { root: parentClasses.textFieldInput }, style: { borderRadius: 0 } }} variant='outlined'>
                                </TextField>} name="calloutsNPSSurveyYellowAlert" defaultValue='' />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={0} className={parentClasses.grid}>
                        <KPILabel labelText="Red alert if below" backgroundColor={redAlert} parentClasses={classes} />
                        <Grid item xs={4}>
                            <Controller
                                control={control} as={<TextField type="number" classes={{ root: parentClasses.textFieldRoot }} InputProps={{ classes: { root: parentClasses.textFieldInput }, style: { borderRadius: 0 } }} variant='outlined'>
                                </TextField>} name="calloutsNPSSurveyRedAlert" defaultValue='' />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

export default AgedCareKPI;

